import React from 'react';
import { Clock, LogOut, Mail, Ban } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useConnect } from '../context/ConnectContext';
import logo from '../assets/farmway-logo.png';

export default function PendingAccess({ suspended = false }) {
  const { user, logout } = useAuth();
  const { openConnect } = useConnect();
  return (
    <div className="grid min-h-screen place-items-center bg-farmway-green px-5 pt-24">
      <div className="w-full max-w-md rounded-3xl border border-white/10 bg-farmway-green-dark/70 p-8 text-center backdrop-blur-xl">
        <img src={logo} alt="Farmway" className="mx-auto h-14 w-14 rounded-2xl object-cover ring-1 ring-farmway-leaf/30" />
        <div className={`mx-auto mt-6 grid h-12 w-12 place-items-center rounded-full ${suspended ? 'bg-red-500/15 text-red-400' : 'bg-farmway-gold/15 text-farmway-gold'}`}>
          {suspended ? <Ban className="h-6 w-6" /> : <Clock className="h-6 w-6" />}
        </div>
        <h1 className="mt-5 display-xl text-3xl text-farmway-cream">{suspended ? 'Account suspended' : 'Access pending'}</h1>
        <p className="mt-3 text-farmway-cream/70" data-testid={suspended ? 'suspended-message' : 'pending-message'}>
          {suspended ? (
            <>Hi {user?.name?.split(' ')[0] || 'there'}, your investor access has been suspended. Please contact the Farmway team if you believe this is a mistake.</>
          ) : (
            <>Hi {user?.name?.split(' ')[0] || 'there'}, your account isn&apos;t onboarded yet. Farmway investor
            access is granted by our team. We&apos;ll be in touch once you&apos;re approved.</>
          )}
        </p>
        <button onClick={openConnect} className="btn-gold mx-auto mt-7">
          <Mail className="h-4 w-4" /> {suspended ? 'Contact Farmway' : 'Request access'}
        </button>
        <button onClick={logout} className="mx-auto mt-4 flex items-center gap-2 text-sm text-farmway-cream/50 hover:text-farmway-cream">
          <LogOut className="h-4 w-4" /> Sign out
        </button>
      </div>
    </div>
  );
}
